/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Avatar } from "antd";

import * as actions from "../../../../../app/modules/Dashboard/_redux/dashboard/dashboardActions";
import { MODULE_NAME_NOTIFICATIONS } from "../../../../../app/modules/Common/constants";
import ReadIcon from '../../../../_assets/logos/readIcon.svg?react';
import { useState } from "react";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

export function UserNotificationsDropdown({ notificationEntities }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const timePassed = (created_at) => {
    const notificationCreatedAt = new Date(created_at);
    const currentTime = new Date();

    // Ensure notificationCreatedAt is a valid date
    if (isNaN(notificationCreatedAt)) {
      return <span>Invalid date</span>;
    }

    // Calculate the time difference in milliseconds
    const timeDifference = currentTime.getTime() - notificationCreatedAt.getTime();

    // If the time difference is negative, return a message indicating the time is in the future
    if (timeDifference < 0) {
      return <span>Time is in the future</span>;
    }

    // Convert milliseconds to seconds, minutes, and days
    const secondsPassed = Math.floor(timeDifference / 1000);
    const minutesPassed = Math.floor(secondsPassed / 60);
    const hoursPassed = Math.floor(minutesPassed / 60);
    const daysPassed = Math.floor(hoursPassed / 24);

    if (daysPassed > 0) {
      return <>{`${daysPassed} day(s) ago`}</>;
    } else if (hoursPassed > 0) {
      return <>{`${hoursPassed} hour(s) ago`}</>;
    } else if (minutesPassed > 0) {
      return <>{`${minutesPassed} min(s) ago`}</>;
    } else {
      return <>{`${secondsPassed} secs ago`}</>;
    }
  };
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const handleScrollY = (container) => {
    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight - 50 && !loading) {
      dispatch(actions.fetchNotifications({ page_size: pageSize }))
        .then(() => {
          setPageSize((prev) => prev + 10);
        })
        .catch(() => setLoading(false));
    }
  };
  return (
    <PerfectScrollbar
      options={perfectScrollbarOptions}
      className="notify scroll my-4"
      style={{ maxHeight: "600px", position: "relative" }}
      onScrollY={handleScrollY}
    >
      {notificationEntities.map((notification, key) => (
        <>
          <a
            key={notification.id || key}
            onClick={() => {
              if (!notification.is_viewed) {
                dispatch(actions.updatedNotifications({ id: notification.id, is_viewed: true }));
              }
              history.push(MODULE_NAME_NOTIFICATIONS[notification.module_name]);
            }}
            className="notify-item"
          >
            <div className="notify-link" style={{ backgroundColor: !notification.is_viewed ? "#F2F2F2" : "", alignItems: "center" }}>
              <div className="mr-4">
                <Avatar size={48} src={"/media/logos/user-alert-notification.svg"} />
              </div>
              <div className="list-text">
                <div className="notification-msg">{notification.message}</div>
                <div> {timePassed(notification.created_at)} </div>
              </div>
              {!notification.is_viewed && (
                <div style={{ paddingLeft: "40px", marginLeft: "auto" }}>
                  {" "}
                  <ReadIcon />{" "}
                </div>
              )}
            </div>
          </a>
        </>
      ))}
    </PerfectScrollbar>
  );
}
